/* eslint-disable */
import { Button as AntdButton } from 'antd'
import Flex from 'components/Flex'
import React from 'react'
import styled, { css } from 'styled-components'
import { COLORS } from 'theme'

const BorderStyle = css`
  &:hover {
    border-color: ${COLORS.GREY_T_85};
  }
  &:focus {
    border-color: ${COLORS.GREY_T_85};
  }
`
const TextContainer = styled.div`
  margin-left: ${props => (props.icon ? '7px' : '')};
  margin-right: ${props => (props.marginRight ? '7px' : '')};
`
const dangerButtonStyles = css`
  background-color: ${COLORS.RED_S_100};
  border-color: ${COLORS.RED_S_100};
`
const dangerStyleButtonStyles = css`
  background-color: ${COLORS.RED_T_80};
  border-color: ${props =>
    props.borderColor ? COLORS.RED_S2_100 : COLORS.RED_T_80};
  color: ${COLORS.RED_S2_100};
  &:hover {
    background-color: ${COLORS.RED_T_80};
    border-color: ${props =>
      props.borderColor ? COLORS.RED_S2_100 : COLORS.RED_T_80};
    color: ${COLORS.RED_S2_100};
  }
  &:focus {
    background-color: ${COLORS.RED_T_80};
    border-color: ${props =>
      props.borderColor ? COLORS.RED_S2_100 : COLORS.RED_T_80};
    color: ${COLORS.RED_S2_100};
  }
`

const secondaryButtonStyles = css`
  background-color: ${COLORS.PRIMARY_PURPLE};
  border-color: ${COLORS.PURPLE_T_80};
  font-weight: 600;
  color: '#FFFFFF';
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    background-color: ${COLORS.PRIMARY_PURPLE};
    border-color: ${COLORS.PURPLE_T_80};
  }
  &:focus {
    background-color: ${COLORS.PRIMARY_PURPLE};
    border-color: ${COLORS.PURPLE_T_80};
  }
`

const secondaryButtonStyles1 = css`
  background-color: #eaedfb;
  border-color: #eaedfb;
  font-weight: 600;
  color: '#3249D7 !important';
  // box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    background-color: #eaedfb !important;
    border-color: #eaedfb !important;
  }
  &:focus {
    background-color: #eaedfb !important;
    border-color: #eaedfb !important;
  }
`

const successButtonStyles = css`
  background-color: ${COLORS.GREEN_T_80};
  border-color: ${COLORS.GREEN_T_80};
  font-weight: 600;
  color: ${COLORS.GREY_P_100};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    background-color: ${COLORS.GREEN_T_80};
    border-color: ${COLORS.GREEN_T_80};
    color: ${COLORS.GREY_P_100};
  }
`
const successTestButtonStyles = css`
  background-color: ${COLORS.GREEN_T_80};
  border: 1px ${COLORS.GREEN_T_80} solid;
  font-weight: 600;
  color: ${COLORS.GREEN_S_100};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    background-color: ${COLORS.GREEN_T_80};
    border-color: ${COLORS.GREEN_T_80};
    color: ${COLORS.GREEN_S_100};
  }
`
const disableButtonStyle = css`
  background-color: #3249d7ad !important;
  border: 1px solid #fff !important;
  color: #fff !important;
  font-weight: 600 !important;

  &:hover,
  &:focus {
    background-color: #3249d7ad !important;
    border: 1px solid #fff !important;
    color: #fff !important;
  }
`
const disabledButtonStyle = css`
  background-color: #b4b4b4 !important;
  border: 1px solid #fff !important;
  color: #fff !important;
  font-weight: 600 !important;

  &:hover,
  &:focus {
    background-color: #b4b4b4 !important;
    border: 1px solid #fff !important;
    color: #fff !important;
  }
`
const roundButtonStyles = css`
  background-color: ${COLORS.PRIMARY_PURPLE};
  border-color: ${COLORS.PURPLE_T_80};
  font-weight: 600;
  padding-top: ${props => (props.padding ? props.padding : '')};
`
const defaultButtonStyles = css`
  color: ${props => (props.color ? props.color : '#30475e;')};
  background-color: ${props => (props.background ? props.background : '')};
  border-color: ${COLORS.PURPLE_T_80};
  &:hover {
    background-color: ${COLORS.PRIMARY};
    color: ${COLORS.WHITE};
    border-color: ${COLORS.PURPLE_T_80};
  }
`

const PlainButton = styled(AntdButton)`
  width: ${props => (props.width ? props.width : '')};
  height: ${props => (props.height ? props.height : '40px')};
  color: ${props =>
    props.type === 'secondary' || props.type === 'colorText'
      ? COLORS.PRIMARY
      : '#FFFFFF'};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '8px')};
  justify-content: center;
  cursor: ${props => props?.disableCursor && 'not-allowed'};
  pointer-events: ${props => (props?.disable ? 'none' : 'auto')};
  ${props => props.type === 'secondary' && secondaryButtonStyles}
  ${props => props.type === 'colorText' && secondaryButtonStyles1}
  ${props => props.type === 'success' && successButtonStyles}
  ${props => props.type === 'successText' && successTestButtonStyles}
  ${props => props.type === 'danger' && dangerButtonStyles};
  ${props => props.type === 'dangerStyle' && dangerStyleButtonStyles};
  ${props => props.type === 'default' && defaultButtonStyles};
  ${props => props.type === 'round' && roundButtonStyles}
  ${props => props.disable && disableButtonStyle}
  ${props => props.disabled && disabledButtonStyle}

  ${BorderStyle}
`
const CircleButton = styled(AntdButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  ${BorderStyle}
`

const Button = props => <AntdButton {...props} />

const Primary = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="primary">
    <Flex>
      {icon}
      <TextContainer icon={!!icon}>{text}</TextContainer>
    </Flex>
  </PlainButton>
)

const Secondary = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="secondary">
    <Flex>
      {icon}
      <TextContainer icon={!!icon}>{text}</TextContainer>
    </Flex>
  </PlainButton>
)

const SecondaryColor = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="colorText">
    <Flex>
      {icon}
      <TextContainer icon={!!icon}>{text}</TextContainer>
    </Flex>
  </PlainButton>
)
const Success = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="success">
    <Flex>
      {icon}
      <TextContainer icon={!!icon}>{text}</TextContainer>
    </Flex>
  </PlainButton>
)

const SuccessText = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="successText">
    <Flex>
      {icon}
      <TextContainer icon={!!icon}>{text}</TextContainer>
    </Flex>
  </PlainButton>
)

const Danger = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="danger">
    <Flex>
      {icon}
      <TextContainer icon>{text}</TextContainer>
    </Flex>
  </PlainButton>
)

const DangerStyle = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="dangerStyle">
    <Flex>
      {icon}
      <TextContainer icon>{text}</TextContainer>
    </Flex>
  </PlainButton>
)

const Default = ({ icon, text, onClick, ...rest }) => {
  return (
    <PlainButton onClick={onClick} {...rest} type="default">
      {icon}
      <TextContainer icon={icon}>{text}</TextContainer>
    </PlainButton>
  )
}

const Round = ({ icon, text, onClick, ...rest }) => {
  return (
    <PlainButton type="round" onClick={onClick} {...rest}>
      {icon}
      <TextContainer>{text}</TextContainer>
    </PlainButton>
  )
}

const Circle = ({ icon, onClick, ...rest }) => {
  return (
    <CircleButton type="circle" onClick={onClick} {...rest}>
      {icon}
    </CircleButton>
  )
}
const IconButton = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="primary">
    <Flex>
      <TextContainer marginRight={true} icon={!!icon}>
        {text}
      </TextContainer>
      {icon}
    </Flex>
  </PlainButton>
)

Button.Primary = Primary
Button.Secondary = Secondary
Button.SecondaryColor = SecondaryColor
Button.Success = Success
Button.SuccessText = SuccessText
Button.Danger = Danger
Button.DangerStyle = DangerStyle
Button.Default = Default
Button.Round = Round
Button.Circle = Circle
Button.IconButton = IconButton

export default Button
